import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { queryClient } from "../App";

const useAddNewCategory = () =>
  useMutation({
    mutationFn: async (data: any) => {
      const response = await AXIOS_RESERVATION.post(`/v1/add-new-category`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["services-components"] });
    },
  });

export default useAddNewCategory;